import React, { useEffect, createElement } from 'react';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { PainSection } from './components/PainSection';
import { OpportunitySection } from './components/OpportunitySection';
import { SolutionSection } from './components/SolutionSection';
import { AuthoritySection } from './components/AuthoritySection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { BonusesSection } from './components/BonusesSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ObjectionBreaker } from './components/ObjectionBreaker';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { TrustBar } from './components/TrustBar';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel safely
    const pixelId = '1225428543097695';
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-gold/30" data-id="element-0">
      <StickyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProof data-id="element-4" />
        <PainSection data-id="element-5" />
        <OpportunitySection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <AuthoritySection data-id="element-8" />
        <WhatsIncluded data-id="element-9" />
        <BonusesSection data-id="element-10" />
        <UrgencySection data-id="element-11" />
        <OfferSection data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <ObjectionBreaker data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>

      <footer className="bg-brand-dark" data-id="element-18">
        <TrustBar data-id="element-19" />
        <div className="py-8 text-center border-t border-white/5" data-id="element-20">
          <p className="text-gray-500 text-sm" data-id="element-21">
            © {new Date().getFullYear()} Megapack Italiano Listo. Todos los
            derechos reservados.
          </p>
          <div className="mt-4 space-x-4 text-xs text-gray-600" data-id="element-22">
            <a href="#" className="hover:text-gray-400" data-id="element-23">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-24">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-25">
              Aviso Legal
            </a>
          </div>
        </div>
      </footer>

      <PurchasePopup data-id="element-26" />
    </div>;
}